import React from 'react'

class PostsLoadMore extends React.Component {
    render(){
        return(
            <div className="postsLoadMore" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0px'  }}>
                No More Posts
            </div>
        )
    }
}

export default PostsLoadMore